"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgAgile = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M9 5.5v-2l-4 3 4 3v-2c2.014 0 4 1.616 4 4s-1.986 4-4 4H2v2h7c2.986 0 6-2.384 6-6s-3.014-6-6-6z' }),
    react_1.default.createElement("path", { d: 'M2.881 10.583c.144-1.372.722-2.6 1.413-3.29l1.414 1.414c-.31.31-.732 1.082-.838 2.085a4.137 4.137 0 00.911 3.083l.508.635H3.783c-.786-1.363-1.03-2.708-.902-3.927zM17 12.5l5 4-5 4v-3h-4.5c2-1 2.5-2 2.5-2h2v-3z' }))); };
exports.default = SvgAgile;
//# sourceMappingURL=Agile.js.map